import React from 'react'
import styles from './TheFooter.module.scss'
import { useTranslation } from 'next-i18next'
import { Footer } from '@climatetrade/components'

const TheFooter: React.FC = () => {
  const { i18n } = useTranslation()

  return (
    <div className={styles.footerContent}>
      <Footer language={i18n.language}/>
    </div>
  )
}

export default TheFooter
